// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.
export const environment = {
	production: false,
	path: "/bookinglink/graphql",  
	apiUrl: "https://betabookingapi.adit.com",
	aditAppUrl: "https://betaapi.adit.com",
	appUrl: "http://localhost:4002",
	cdnUrl: {
		'root': 'https://betacdn.adit.com',
		'common': 'https://cdn.adit.com/common'
	},
	stripe: {
		apiKey: 'pk_test_51Ixs95BTDnqJlDMTBv1XdQXE7Ny65HKkGAPB3j2IE1wwqYSgLW6RF1HzBDZoy8pSYsX13rxwW321P5d1LQqvk8ym002ZfUFPEG'
	},
	aditUrl: "https://adit.com",
}


/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
